import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  ConfirmationTable,
  ConfirmationTableFilters,
  useDefaultHtzConfirmationListRequest,
} from "@/services/backend/htz/confirmations/components/confirmation-table";
import { CreateConfirmationButton } from "@/services/backend/htz/confirmations/components/create-confirmation-button";
import t from "@/lang/lang";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function ConfirmationIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  const [request, setRequest] = useState(
    useDefaultHtzConfirmationListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!data) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Auftragsbestätigungen")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Auftragsbestätigungen")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <ConfirmationTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateConfirmationButton
                processId={processId!}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <ConfirmationTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
